import { TFunction } from 'i18next'
import React from 'react'

import SelectorButton from '@/atoms/SelectorButton/SelectorButton'
import { Stack } from '@/atoms/System'
import { useTranslation } from '@/lib/i18n/i18n'
import { getCurrencySign } from '@/lib/number-utils'
import { fontSecondary } from '@/refactor/colors'
import { font } from '@/refactor/fonts'
import styled from '@/styles'
import { DefaultProps } from '@/travelsuit'
import { UserCurrency } from '@/types/common'

interface IProps extends DefaultProps {
	currency: UserCurrency
	horizontal?: boolean
	onChange?(currency: UserCurrency): void
}

const Title = styled.div`
	${font({ size: 14, weight: 800 })}
	display: flex;
	gap: 10px;
`

const Label = styled.div`
	color: ${fontSecondary};
	${font({ size: 12 })}
`

const AVAILABLE_CURRENCIES_FOR_SELECT = [UserCurrency.USD, UserCurrency.EUR, UserCurrency.GBP]

const getCurrencyLabel = (t: TFunction) => ({
	[UserCurrency.EUR]: t('currency-selector.currency-labels.EUR'),
	[UserCurrency.USD]: t('currency-selector.currency-labels.USD'),
	[UserCurrency.GBP]: t('currency-selector.currency-labels.GBP'),
	[UserCurrency.AUD]: t('currency-selector.currency-labels.AUD'),
	[UserCurrency.SEK]: t('currency-selector.currency-labels.SEK'),
	[UserCurrency.ILS]: t('currency-selector.currency-labels.ILS'),
})

const CurrencySelector: React.FunctionComponent<IProps> = (props) => {
	const { className, currency, onChange, horizontal } = props
	const { t } = useTranslation()

	const currencyLabel = React.useMemo(() => getCurrencyLabel(t), [t])

	return (
		<Stack className={className} direction={horizontal ? 'row' : 'column'} gap={2} data-test="CurrencyContainer">
			{AVAILABLE_CURRENCIES_FOR_SELECT.map((cur) => (
				<SelectorButton
					key={cur}
					selected={cur === currency}
					onClick={() => onChange?.(cur)}
					width={horizontal ? 180 : '100%'}
					data-test={`Currency-${cur}`}
				>
					<Title>
						<span>{cur}</span>
						<span>{getCurrencySign(cur)}</span>
					</Title>
					<Label>{currencyLabel[cur]}</Label>
				</SelectorButton>
			))}
		</Stack>
	)
}

export default CurrencySelector
